import PlayGame from '../scenes/PlayGame';

export default class ProgressBar extends Phaser.GameObjects.Container {
  constructor({scene = null,
               x = 0,
               y = 0,
               text = "", // default text to show in progress bar
               font = "30px Arial Black",
               fontColor = "#ffffff",
               fontColorShadow = "#000000",
               depth = 1200000,
               origin = {x: 0.5, y: 0.5},
               clickFunction = null, 
               clickFunctionData = null,
               width = 200,
               height = 50,
               radius = 5,
               borderWidth = 2,
               selectedBorderColor = null,
               addToScene = true,
               onComplete = ()=>{
                // do nothing by default
               }}) {
    super(scene);
    this.scene = scene;
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
    this.radius = radius;
    this.borderWidth = borderWidth;
    this.selectedBorderColor = selectedBorderColor;
    this.clickFunction = clickFunction;
    this.clickFunctionData = clickFunctionData;
    this.setDepth(depth);
    if (addToScene) {
      scene.add.existing(this);
    }

    this.mainBox = new Phaser.GameObjects.Graphics(scene);
    this.mainBox.setDepth(depth - 10); // bottom most object in this container
    this.add(this.mainBox);

    this.bar = scene.add.rectangle(3, 3, 1, height - 6, 0xffca3a);
    this.bar.setOrigin(0);
    this.bar.setDepth(depth - 9); // to be above mainBox
    this.add(this.bar);

    this.barText = new Phaser.GameObjects.Text(scene, 0, 0, text, {font: font, color: fontColor, boundsAlignH: "center", boundsAlignV: "middle", align: 'center'});
    this.barText.setShadow(3, 3, fontColorShadow, 3, true);
    this.barText.setOrigin(origin.x, origin.y);
    this.barText.setDepth(depth + 1); // should be above everything else in this container
    this.add(this.barText);

    this.drawMainBox();
  }

  drawMainBox(theme = null) {
    const activeTheme = theme || (PlayGame.getActiveTheme ? PlayGame.getActiveTheme(this.scene) : null);
    const bgCol = activeTheme ? PlayGame.toColorInt(activeTheme.button_bg_color) : 0x540016;
    const borderCol = activeTheme ? PlayGame.toColorInt(this.selectedBorderColor != null ? this.selectedBorderColor : activeTheme.button_border_color) : (this.selectedBorderColor != null ? PlayGame.toColorInt(this.selectedBorderColor) : 0xffca3a);
    const barCol = activeTheme ? PlayGame.toColorInt(activeTheme.accent_color) : 0xffca3a;

    if (this.mainBox) {
      this.mainBox.clear();
      this.mainBox.fillStyle(bgCol, 1);
      this.mainBox.fillRoundedRect(0, 0, this.width, this.height, this.radius);
      this.mainBox.lineStyle(this.borderWidth, borderCol, 1);
      this.mainBox.strokeRoundedRect(0, 0, this.width, this.height, this.radius);
    }
    if (this.bar) {
      this.bar.setFillStyle(barCol);
    }
  }

  applyTheme(theme = null) {
    this.drawMainBox(theme);
  }

  setProgress({perc, onComplete = null, instant=false, duration = 700, reset = false}) { // 0-100 
    if (reset) {
      if (this.bar.tween) {
        this.bar.tween.stop();
      }
      this.bar.displayWidth = (this.width - 6);
    }
    let newWidth = (this.width - 6) * (Math.min(Math.floor(perc)/100, 99));
    this.bar.tween = this.scene.tweens.add({
      targets: this.bar,
      displayWidth: Math.max(newWidth,0.5),
      duration: instant ? 0 : duration,
      ease: 'sine.inout',
      onComplete: (onComplete)
        ? ()=> { this.visible && onComplete.call(this.scene) }
        : ()=>{},
    });
  }

  click(args) {
    this.clickFunction.call(this.scene, args, this.clickFunctionData);
  }

}